// src/components/BackArrow.tsx
import React from 'react';
import { useSiteContext } from '../SiteContext';

const BackArrow: React.FC = () => {
  const { goBack } = useSiteContext(); // Get the goBack function from the context

  const handleClick = () => {
    goBack(); // Go back to the previous page in the history stack
  };

  return (
    <button onClick={handleClick} style={styles.button}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={styles.icon}
      >
        <path d="M19 12H5" />
        <path d="M12 19l-7-7 7-7" />
      </svg>
    </button>
  );
};

const styles = {
  button: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'bottom',
    justifyContent: 'center',
    lineHeight: 0,
  },
  icon: {
    color: '#000',
    verticalAlign: 'bottom',
    marginRight: '10px',
  },
};

export default BackArrow;
